<template>
<div class="ActivityMgt">
    <keep-alive :include="includeList">
        <router-view></router-view>
    </keep-alive>
</div>
</template>

<script>
export default {
    name: 'ActivityMgt',
    data() {
        return {
            includeList: ['BBActivityList', 'BBActivityGoodsList', 'BBActivityOrderList', 'BBOrderList', 'BBWriteoffList', 'BBRefundList']
        }
    },
    mounted() {

    },
    activated() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ActivityMgt {
}
</style>
